import { useContext } from 'react'
import { SurveyContext } from './index'

const useSurvey = () => useContext(SurveyContext)

export default useSurvey
